import React, { Component } from 'react';
import img from '../../../assets/Broker/BrokerPlans_content/5083b4b5a163b456731e82e1c8357c29_html_1b412ba2e27b5cb7.png';
import img1 from '../../../assets/Broker/BrokerPlans_content/5083b4b5a163b456731e82e1c8357c29_html_d6a18391f7f110e6.png';
class BrokerPlansContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b > Broker Plans and Profiles:</b></p>
                <p>Admin assigns plan and profiles to Broker. Broker can view assigned plan and profiles in "Our Plans" menu .</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img1} />
                <p ><b > Profile View:</b></p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
            </div>
        )
    }
}
export default BrokerPlansContent;
